import { Component, OnDestroy, OnInit } from '@angular/core';
import { take, takeUntil } from 'rxjs/operators';
import { forkJoin, Subject } from 'rxjs';
import { MobileMenuService } from '../../../../shared/services/mobile-menu.service';
import { mobileMenu } from '../../../../../data/mobile-menu';
import { MobileMenuItem } from '../../../../shared/interfaces/mobile-menu-item';
import { CategoriaAttualeService } from '../../../../shared/services/custom/categoria-attuale.service';
import { AccountService } from 'src/app/shared/services/custom/account.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-mobile-menu',
    templateUrl: './mobile-menu.component.html',
    styleUrls: ['./mobile-menu.component.scss']
})
export class MobileMenuComponent implements OnDestroy, OnInit {
    private destroy$: Subject<any> = new Subject();

    isOpen = false;
    links: MobileMenuItem[] = mobileMenu;

    constructor(public mobilemenu: MobileMenuService, private categorieService : CategoriaAttualeService,
        public account : AccountService, private router : Router) {
        this.categorieService.categorie$.pipe(take(1)).subscribe(r => {
            let categorieLink = this.links.find(link => link['url'] == '/shop/catalog');
            for (let categoria of r[0]) {
                let url = '/shop/catalog/' + categoria.codicefamiglia;

                let sottofamiglie = r[1].filter(obj => obj.codicefamiglia == categoria.codicefamiglia);
                sottofamiglie = sottofamiglie.map(obj => ({
                    type: 'link',
                    label: obj.descrizione,
                    url: url + '-' + obj.codicesfamiglia,
                }));
                
                categorieLink['children'].push({
                    type: 'link',
                    label: categoria.descrizione,
                    url: url,
                    children: sottofamiglie
                });
            }
        });
    }

    ngOnInit(): void {
        this.mobilemenu.isOpen$.pipe(takeUntil(this.destroy$)).subscribe(isOpen => this.isOpen = isOpen);
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    onItemClick(event: MobileMenuItem): void {
        if (event.type === 'link') {
            this.mobilemenu.close();
        }

        if (event.type == 'button') {
            this.mobilemenu.close();
            this.account.logout();
            this.router.navigateByUrl('/auth/login');
        } 

        // if (event.data && event.data.language) {
        //     console.log(event.data.language); // change language
        // }
    }
}
